import { useCallback, useState } from 'react';
import { css } from '@linaria/atomic';
import { Button } from '../../button';
import { MAX_ZOOM, MIN_ZOOM, useImagePreviewActions } from '../provider/image-preview.provider';
import { controlStyles, IconButtonStyles, MAX_RANGE_VALUE, MIN_RANGE_VALUE, STEP } from './constants';

const rangeInputStyle = css`
  cursor: pointer;
`;

const mapRange = (value, inMin, inMax, outMin, outMax) => {
  return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
};

export const ZoomSlider = () => {
  const { changeZoom } = useImagePreviewActions();
  const [value, setValue] = useState(MIN_RANGE_VALUE);

  const updateZoom = (newValue: number) => {
    const clamped = Math.min(MAX_RANGE_VALUE, Math.max(MIN_RANGE_VALUE, newValue));
    setValue(clamped);
    const zoomValue = mapRange(clamped, MIN_RANGE_VALUE, MAX_RANGE_VALUE, MIN_ZOOM, MAX_ZOOM);
    changeZoom(zoomValue);
  };

  const handleMinus = useCallback(() => updateZoom(value - STEP), [value]);
  const handlePlus = useCallback(() => updateZoom(value + STEP), [value]);
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => updateZoom(e.target.valueAsNumber), []);

  return (
    <div className={controlStyles}>
      <Button
        iconName='minus-small'
        color='white'
        className={IconButtonStyles}
        onClick={handleMinus}
        style={{ background: 'transparent' }}
      />
      <input
        type='range'
        min={MIN_RANGE_VALUE}
        max={MAX_RANGE_VALUE}
        value={value}
        onChange={handleChange}
        className={rangeInputStyle}
      />
      <Button
        iconName='plus-small'
        color='white'
        className={IconButtonStyles}
        onClick={handlePlus}
        style={{ background: 'transparent' }}
      />
    </div>
  );
};

ZoomSlider.displayName = 'ZoomSlider';
